import React from "react";
import { RateAppointmentContext } from "../context/rateAppointmentContext";
import { IRateAppointment, IStarQestions } from "../interface/iRateAppointment";
import RatingCategory from "./ratingCategory";
import { Box } from "@mui/material";

const StarQuestions = (): React.JSX.Element => {
  const {
    rateAppointmentDto,
    setRateAppointmentDto,
  }: {
    rateAppointmentDto: IRateAppointment;
    setRateAppointmentDto: React.Dispatch<
      React.SetStateAction<IRateAppointment>
    >;
  } = React.useContext(RateAppointmentContext);

  return (
    <Box sx={{ pt: 6 }}>
      {rateAppointmentDto.starQestions.map(
        (question: IStarQestions, index: number) => (
          <RatingCategory
            key={question.text}
            text={question.text}
            index={index}
            setRateAppointmentDto={setRateAppointmentDto}
            rateAppointmentDto={rateAppointmentDto}
          />
        )
      )}
    </Box>
  );
};

export default StarQuestions;
